import React from 'react';

import SingleButton from './SingleButton';
import SingleButtonBlock from './SingleButtonBlock';
import DraftColorPicker from './DraftColorPicker';
import BlockSelect from './BlockSelect';

const INLINE_STYLES = [
    {label: 'Bold', style: "BOLD", disabled: false},
    {label: 'Italic', style: "ITALIC", disabled: false},
    {label: 'Underline', style: "UNDERLINE", disabled: false},
    {label: 'Link', style: "LINK", disabled: true},
];

const BLOCK_TYPES = [
    {label: 'H1',  value: 'header-one', disabled: false},
    {label: 'H2', value: 'header-two', disabled: false},
    {label: 'H3', value: 'header-three', disabled: false},
    {label: 'P',  value: 'unstyled', disabled: false},
];

const QUOTE = {
    label: 'Quote',
    value: 'blockquote',
    disabled: false,
};

const TopTools = (props)=> {
    const {editorState} = props;
    let currentStyle = editorState.getCurrentInlineStyle();
    const selection = editorState.getSelection();
    const block = editorState.getCurrentContent().getBlockForKey(selection.getStartKey());
    const blockType = block.getType();


    const handleClick= (e)=>{
        e.stopPropagation();
    };

    return (
    <div className="richutils__top" onClick={handleClick}>
        {INLINE_STYLES.map(inline=>{
            return (
            <SingleButton key={inline.label}
                          label={inline.label}
                          style={inline.style}
                          disabled={inline.disabled}
                          onToggle={props.onToggle}
                          active={currentStyle.has(inline.style)}
            />
            )
        })}
        <SingleButtonBlock label={QUOTE.label}
                           value={QUOTE.value}
                           disabled={QUOTE.disabled}
                           active={blockType === QUOTE.value}
                           onToggle={props.onToggleBlock}
        />
        <BlockSelect onToggle={props.onToggleBlock}
                     options={BLOCK_TYPES}
                     blockType={blockType}
        />
    </div>
    )
}

export default TopTools;


// WEBPACK FOOTER //
// ./src/_app/estimations/editor/tools/RichUtils/TopTools.js